import React from 'react';
import PhoneInput from './PhoneInput';
import { formatPhone } from '../utils/formatters';

// Additional contacts (2nd, 3rd, 4th...) for a transaction form. Each has a Signer checkbox,
// on by default. Unchecked = still on transaction emails, but not listed as a signer.
const EMPTY = { firstName: '', lastName: '', role: '', phone: '', email: '', signer: true };

export default function AdditionalContactsEditor({ value = [], onChange, styles, rolePlaceholder = 'Co-tenant, spouse, etc.' }) {
  const set = (id, field, v) => onChange(value.map((c) => (c.id === id ? { ...c, [field]: field === 'phone' ? formatPhone(v) : v } : c)));
  const field = (c, name, label, el) => (
    <div style={styles.inputGroup}>
      <label style={styles.label}>{label}</label>
      {el || <input type={name === 'email' ? 'email' : 'text'} value={c[name] || ''} onChange={(e) => set(c.id, name, e.target.value)} placeholder={name === 'role' ? rolePlaceholder : undefined} style={styles.input} />}
    </div>
  );
  return (
    <fieldset style={styles.fieldset}>
      <legend style={styles.legend}>Additional Contacts</legend>
      <button type="button" onClick={() => onChange([...value, { ...EMPTY, id: Date.now() }])} style={{ padding: '8px 16px', backgroundColor: '#D4AF37', color: '#000', border: 'none', borderRadius: '4px', fontWeight: '600', cursor: 'pointer', marginBottom: '12px' }}>
        + Add Contact
      </button>
      {value.length === 0 && <p style={styles.label}>No additional contacts yet.</p>}
      {value.map((c, idx) => (
        <div key={c.id} style={{ border: '1px solid #DDD', borderRadius: '6px', padding: '16px', marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <strong>Contact {idx + 2}</strong>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 400, cursor: 'pointer' }} title="Uncheck if this person does not sign. They still get the transaction emails.">
                <input type="checkbox" checked={c.signer !== false} onChange={(e) => set(c.id, 'signer', e.target.checked)} /> Signer
              </label>
            </span>
            <button type="button" onClick={() => onChange(value.filter((x) => x.id !== c.id))} style={{ background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontWeight: '600' }}>Remove</button>
          </div>
          <div style={styles.twoColumn}>
            {field(c, 'firstName', 'First Name')}
            {field(c, 'lastName', 'Last Name')}
            {field(c, 'role', 'Role / Relationship')}
            {field(c, 'phone', 'Phone', <PhoneInput value={c.phone || ''} onChange={(e) => set(c.id, 'phone', e.target.value)} style={styles.input} />)}
            {field(c, 'email', 'Email')}
          </div>
        </div>
      ))}
    </fieldset>
  );
}
